<template>
    <div class="project-invitation" v-if="show">
        <sd-mask>
            <div class="invitation-content">
                <div class="img">
                    <!-- <img src="@/assets/img/invitation.png" /> -->
                    <div class="img-swiper">
                        <swiper :data="list" hiddenIndicator @change="val => indicatorIndex = val" percent @itemclick="view"></swiper>
                        <!-- <sd-swiper :num="list.length" :index.sync="indicatorIndex" class="content">
                            <div class="background-image swiper-content" v-for="(item, index) in list" :key="index">
                                <img :src="item.img" />
                                <sd-button>View Details</sd-button>
                            </div>
                        </sd-swiper> -->
                    </div>
                    <!-- <sd-button @click.native="view">View Details</sd-button> -->
                    <div class="indicator">
                        <div class="circular" :class="[{'active': index == indicatorIndex}]" v-for="(i, index) in list.length" :key="index"></div>
                    </div>
                </div>
                <div class="close" @click="show = false">
                    <img src="@/assets/img/sheet_close.png" />
                </div>
            </div>
        </sd-mask>
    </div>
</template>

<script>
import sdMask from "./mask";
import sdButton from "./button";
import swiper from "../base/swiper2"
import cache from "@/utils/cache"

export default {
    name: "sd-invitation",
    components: { sdMask, sdButton, swiper },
    data() {
        return {
            show: false,
            indicatorIndex: 0,
            list: []
        }
    },
    created() {
        let userinfo = this.$store.state.user.userinfo;
        let username = userinfo.user_name;
        let adRecord = cache.getLocal('adRecord') || {};
        let viewedItems = adRecord[username] || [];
        this.$apis.common.getAD({
            type: 3,
            bannerType: 3
        }).then(res => {
            let list = (res.data || []).filter(item => {
                return !viewedItems.includes(item.id)
            });
            if(list.length) {
                this.list = list.map(item => {
                    item = {
                        ...item,
                        img_path: this.$utils.setSourcePath(item.path)
                    }
                    return item;
                })
                this.show = true;
            }
        })
    },
    methods: {
        view(item) {
            let userinfo = this.$store.state.user.userinfo;
            let username = userinfo.user_name;
            let adRecord = cache.getLocal('adRecord') || {};
            console.log(adRecord)
            let viewedItems = adRecord[username] || [];
            viewedItems.push(item.id);
            adRecord[username] = viewedItems;
            console.log(adRecord)
            // return;
            cache.setLocal('adRecord', adRecord)

            let path = '/', query = {id: item.content}
            switch(item.content_type) {
                case "1":
                    window.location.href = item.content
                    return;
                case "2":
                    path = "/brand-detail";
                    if(item.content == '0') path = "/brand";
                    break;
                case "3":
                    path = "/product-detail"
                    if(item.content == '0') path = "/product";
                    break;
                case "4":
                    path = "/cases-detail"
                    if(item.content == '0') path = "/cases";
                    break;
                case "5":
                    path = "/cases-subject"
                    if(item.content == '0') path = "/cases";
                    break;
                case "6":
                    path = "/template-detail"
                    if(item.content == '0') path = "/template";
                    query = {
                        uuid: item.content
                    }
                    break;
            }
            this.show = false;
            this.$router.push({
                path, query
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.project-invitation {

    .invitation-content {
        text-align: center;
        margin-top: 75px;

        .img {
            margin: auto;
            width: 327px;
            height: 436px;
            display: flex;
            position: relative;
            flex-direction: column;
            align-items: center;
            // background-color: white;
            border-radius: 8px;
            overflow: hidden;

            .img-swiper {
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                position: absolute;

                /deep/ {
                    .page-swiper {
                        width: 100%;

                        .swiper-content {
                            position: relative;
                        }
                    }
                }
            }

            .button {
                position: absolute;
                bottom: 46px;
                width: 280px;
                background: white;
                color: #E22F25;
                font-size: 16px;
                font-weight: 600;
            }

            .indicator {
                display: flex;
                position: absolute;
                bottom: 20px;

                .circular {
                    width: 10px;
                    height: 10px;
                    background: rgba(255,255,255,0.5);
                    border-radius: 50%;
                    border: 1px solid rgba(255,255,255,0.5);
                    box-sizing: border-box;
                    margin-right: 15px;

                    &:last-child {
                        margin-right: 0;
                    }

                    &.active {
                        background: rgba(255,255,255,1);
                    }
                }
            }
        }

        .close {
            margin: auto;
            width: 32px;
            height: 32px;
            margin-top: 24px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/common/invitation.vue